<template>
    <LsInfoRow
        class="ls-info-row-scope"
        :left-image="require('./assets/scope.svg')"
        label="Scope"
        :value="scope({ objectContainingScope: schedule, property })"
    >
        <v-popover v-if="time" test-id="pop-over">
            <img :src="require('@/assets/info.svg')" test-id="info" />
            <template slot="popover">
                <div class="ls-info-row-scope--popover">
                    <div>
                        <span>Old scope:</span>
                        <span>{{
                            scope({ objectContainingScope: schedule.last_scope_change })
                        }}</span>
                    </div>
                    <div>
                        <span>Old price per service:</span>
                        <span
                            >{{ schedule.last_scope_change.old_scope_price | currency }} + T&S Fee +
                            Tax</span
                        >
                    </div>
                    <div>
                        <span>Changed by:</span>
                        <span>{{ schedule.last_scope_change.user | fullName }}</span>
                    </div>
                    <div>
                        <span>Changed on:</span>
                        <span>{{ time }}</span>
                    </div>
                </div>
            </template>
        </v-popover>
    </LsInfoRow>
</template>

<script>
import VueTypes from 'vue-types';
import _ from 'lodash';
import { lsPropTypeHelpers } from 'ls-vue-common';
import { lsHelpers } from '@/helpers';
import LsInfoRow from '../LsInfoRow/LsInfoRow.vue';

export default {
    name: 'LsInfoRowScope',
    components: {
        LsInfoRow,
    },
    props: {
        schedule: VueTypes.shape({
            scope_full: VueTypes.custom(lsPropTypeHelpers.booleanOrNull).isRequired,
            scope_front: VueTypes.custom(lsPropTypeHelpers.booleanOrNull).isRequired,
            scope_back: VueTypes.custom(lsPropTypeHelpers.booleanOrNull).isRequired,
            last_scope_change: VueTypes.oneOfType([
                VueTypes.shape({
                    old_scope_full: VueTypes.bool.isRequired,
                    old_scope_front: VueTypes.bool.isRequired,
                    old_scope_back: VueTypes.bool.isRequired,
                    old_scope_price: VueTypes.number.isRequired,
                    user: VueTypes.shape({
                        first_name: VueTypes.string.isRequired,
                        last_name: VueTypes.string.isRequired,
                    }).isRequired,
                    created_at: VueTypes.string.isRequired,
                }),
                VueTypes.oneOf([null]),
            ]),
        }).isRequired.loose,
        property: VueTypes.shape({
            info: VueTypes.shape({
                mowing_preferences: VueTypes.shape({
                    scope: VueTypes.string.isRequired,
                }).isRequired.loose,
            }).isRequired.loose,
        }).isRequired.loose,
    },
    computed: {
        time() {
            const { last_scope_change } = this.schedule;

            if (_.isNil(last_scope_change)) {
                return null;
            }

            return lsHelpers.parseTimestamp({
                timestamp: last_scope_change.created_at,
            });
        },
    },
    methods: {
        scope({ objectContainingScope, property = {} }) {
            let { scope_full, scope_front, scope_back } = objectContainingScope;

            if (_.isNull(scope_full)) {
                scope_full = property.info.mowing_preferences.scope === 'all';
                scope_front = property.info.mowing_preferences.scope === 'frontonly';
                scope_back = property.info.mowing_preferences.scope === 'backonly';
            }

            if (scope_full || objectContainingScope.old_scope_full) {
                return 'Full property';
            }

            if (scope_front || objectContainingScope.old_scope_front) {
                return 'Front-yard only';
            }

            if (scope_back || objectContainingScope.old_scope_back) {
                return 'Backyard only';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-info-row-scope--popover {
    width: 240px;
    div {
        display: flex;
        flex-direction: column;
        font-weight: $medium;
        span:first-child {
            font-weight: $bold;
            color: $secondary-dark;
        }

        span:last-child {
            font-weight: $light;
            padding: 3px 0 5px 0;
        }
    }
    div:not(:last-child) {
        margin-bottom: 5px;
    }
}
</style>
